import { useContext } from 'react';

import { GlobalDrawerContext } from 'common/contexts/GlobalDrawerContext';

export function useGlobalDrawer() {
    return useContext(GlobalDrawerContext);
}
